import CompanyAvailabilityEmployeeCell from './CompanyAvailabilityEmployeeCell';

export default CompanyAvailabilityEmployeeCell;
